import { useEffect } from "react";

import { useLatest } from "../";

import { isDev, isFunction } from "./helpers";

/**
 * @title useUnmount
 */
export type UseUnmount = (
  /**
   * clear function
   */
  fn: () => void
) => void;

export function useUnmount(fn: () => void) {
  if (isDev) {
    if (!isFunction(fn)) {
      console.error(`useUnmount expected parameter is a function, got ${typeof fn}`);
    }
  }

  const fnRef = useLatest(fn);

  useEffect(
    () => () => {
      fnRef.current();
    },
    [fnRef]
  );
}
